let resetToken;
let exportToken;
let invitationToken;

export const captureResetToken = (token) => {
  if (token) resetToken = token;
  return resetToken;
};

export const captureExportToken = (token) => {
  if (token) exportToken = token;
  return exportToken;
};

export const captureInvitationToken = (token) => {
  if (token) invitationToken = token;
  return invitationToken;
};

export const clearResetToken = () => {
  resetToken = undefined;
};

export const clearInvitationToken = () => {
  invitationToken = undefined;
};

export const clearSensitiveCredentials = () => {
  resetToken = undefined;
  exportToken = undefined;
  invitationToken = undefined;
};
